import React, { DOMElement } from 'react'
import { Dialog, DialogAppendToType } from 'primereact/dialog'
import { PropsType } from '../../../models/util'

export interface DialogProps extends PropsType {
    visible: boolean
    onHide: () => void
    onShow?: () => void
    blockScroll?: boolean
    header?: React.ReactNode
    footer?: React.ReactNode
    appendTo?: DialogAppendToType
    baseZIndex?: number
    resizable?: boolean
    closable?: boolean
    className?: string
    style?: any
}

export const LuxDialog = (props: DialogProps) => {
    return (
        <Dialog
            maskClassName="wardrobe-dialog"
            {...props}
            footer={props.footer ? props.footer : <div></div>}>
            {props.children ? props.children : <></>}
        </Dialog>
    )
}
